module.exports = __webpack_public_path__ + "static/media/righttf.ebe9c93a.png";